import BreadCrumb from "Common/BreadCrumb";
import React from "react";
import {Container} from "react-bootstrap";
import FilterIndex from "./FilterIndex";

const ProductGrid = () => {
    document.title = "Product grid all product filter";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Products Grid" pageTitle="Products"/>
                    <FilterIndex/>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default ProductGrid;